<div class="initials {{lastLetter ? 'initials-color-' + lastLetter : 'initials-color'}} d-flex"
    [ngStyle]="style">
  <div
    class="character align-self-center align-content-center"
    [ngStyle]="{ fontSize: fontSize }">{{initials}}</div>
</div>
